import React, { ReactElement, useState, useRef } from 'react';

import { useTranslation } from 'next-i18next';
import { IconButton, Spinner } from 'components';
import { Row } from 'components/layout';
import ButtonV3 from 'components/ComponentV2/ButtonV3';
import { Tooltip } from 'components/Tooltip/Tooltip.component';
import EditSocietyProfileInfo from '../EditSocietyProfileInfo';
import { useSocietyProfile } from '../UseSocietyProfile.hook';
import SaveChangesModal from '../SaveChangesModal';

import styles from './EditSocietyProfile.module.scss';

export const EditSocietyProfile = (): ReactElement => {
  const formRef = useRef<HTMLFormElement>();

  const societyProfileData = useSocietyProfile();
  const { slug, isLoading } = societyProfileData;
  const [t] = useTranslation('common');

  const [isOpenSaveModal, setIsOpenSaveModal] = useState(false);
  const [isShowSaveModal, setIshowSaveModal] = useState(false);

  const onCancel = () => {
    setIsOpenSaveModal(false);
    history.back();
  };

  if (!societyProfileData?.societyProfile)
    return <Spinner size="large" wrapper />;

  return (
    <>
      <Row className={styles.Header} justify="space-between">
        <Row align="center">
          <IconButton
            size="small"
            iconName="close"
            className={styles.cancelIcon}
            onClick={() => {
              if (isShowSaveModal) {
                setIsOpenSaveModal(true);
              } else {
                history.back();
              }
            }}
          />
          <p className={styles.HeaderTitle}>{t('edit-profile')}</p>
        </Row>
        <Row className={styles.buttonsRow}>
          <Tooltip
            content={t('view-profile-tooltip')}
            position="bottom"
            color="dark"
            className={styles.tooltip}
            hasWhitespaceNoWrap={false}
          >
            <a href={`/societies/${slug}`} target="_blank" rel="noreferrer">
              <ButtonV3
                variant="contained"
                color="secondary"
                type="button"
                className={styles.buttons}
                size="small"
                borderRadius={8}
              >
                {t('view-profile')}
              </ButtonV3>
            </a>
          </Tooltip>
          <ButtonV3
            type="submit"
            className={styles.buttons}
            form="society-form"
            size="small"
            borderRadius={8}
            isLoading={isLoading}
          >
            {t('save-changes')}
          </ButtonV3>
        </Row>
      </Row>
      <div></div>

      <div className={styles.content}>
        <section className={styles.SocietyProfile} data-testid="SocietyProfile">
          <EditSocietyProfileInfo
            reference={formRef}
            setIshowSaveModal={setIshowSaveModal}
            {...societyProfileData}
          />
        </section>
      </div>
      {isOpenSaveModal ? (
        <SaveChangesModal
          isOpen={isOpenSaveModal}
          onClose={onCancel}
          onSave={() => {
            formRef?.current?.submitForm();
            onCancel();
          }}
          setOpen={setIsOpenSaveModal}
        />
      ) : null}
    </>
  );
};
